import CoreLocationDetails from './CoreLocationDetails';

export { type CoreLocationDetailsProps } from './CoreLocationDetails';
export default CoreLocationDetails;
